import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-16 sm:py-24 px-4" data-id="element-107">
      <div className="max-w-3xl mx-auto text-center" data-id="element-108">
        <div className="text-5xl sm:text-6xl mb-6" data-id="element-109">🛡️</div>

        <h2 className="text-2xl sm:text-4xl font-serif font-black text-text-main mb-6 uppercase" data-id="element-110">
          Reclaim Your Time or Your Money Back
        </h2>

        <p className="text-text-sec text-base sm:text-lg leading-relaxed font-medium max-w-2xl mx-auto mb-8" data-id="element-111">
          7-Day "No Questions Asked" Guarantee. If this bundle doesn't save you
          hours of work or isn't exactly what you expected, we will refund your
          money. One email, and it's done.
        </p>

        <a href="#" className="text-primary font-medium text-sm hover:underline" data-id="element-112">
          Read the full refund policy
        </a>
      </div>
    </section>;
}